var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarouselRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.4,
    height: 40.262,
    viewBox: "0 0 23.4 40.262",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9110835_chevron_left_arrow_icon",
    "data-name": "9110835_chevron_left_arrow_icon",
    d: "M23.448,23.424,6.586,6.562,9.855,3.293,29.986,23.424,9.855,43.555,6.586,40.286Z",
    transform: "translate(-6.586 -3.293)",
    fill: "#111010",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarouselRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carousel-right.602ef60beaa51324f279a1b859d9e9c8.svg";